export const DEMO_OPEN_AI_REQUEST = "DEMO_OPEN_AI_REQUEST";
export const DEMO_OPEN_AI_SUCCESS = "DEMO_OPEN_AI_SUCCESS";
export const DEMO_OPEN_AI_FAILURE = "DEMO_OPEN_AI_FAILURE";
